import { Link } from 'react-router-dom';

export default function Cookies() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium">
            ← Volver a inicio
          </Link>
        </div>

        {/* Content */}
        <div className="bg-white shadow-sm rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Política de Cookies
          </h1>

          <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                1. ¿Qué son las cookies?
              </h2>
              <p>
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (ordenador, tablet, smartphone, etc.) cuando visita un sitio web. Las cookies permiten que el sitio web recuerde sus acciones y preferencias (como el idioma, el tamaño de fuente y otras preferencias de visualización) durante un período de tiempo, de modo que no tenga que volver a configurarlas cada vez que regrese al sitio o navegue de una página a otra.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                2. ¿Cómo utilizamos las cookies?
              </h2>
              <p>
                En <strong>aurionenergy.es</strong> utilizamos cookies para mejorar la experiencia de navegación de nuestros usuarios, analizar el tráfico del sitio web y personalizar el contenido. A continuación, detallamos los tipos de cookies que utilizamos:
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                3. Tipos de cookies utilizadas
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                3.1. Cookies técnicas (necesarias)
              </h3>
              <p>
                Estas cookies son esenciales para el funcionamiento del sitio web y permiten la navegación y el uso de las diferentes opciones o servicios que existen en él. Sin estas cookies, el sitio web no funcionaría correctamente.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Finalidad:</strong> Permitir la navegación por el sitio web, gestionar sesiones de usuario y recordar preferencias básicas.</li>
                <li><strong>Duración:</strong> Sesión (se eliminan al cerrar el navegador) o persistentes (permanecen hasta su fecha de expiración).</li>
                <li><strong>Titular:</strong> AURION ENERGY S.L.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                3.2. Cookies de preferencias
              </h3>
              <p>
                Estas cookies permiten que el sitio web recuerde información que cambia la forma en que se comporta o se ve, como su idioma preferido o la región en la que se encuentra.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Finalidad:</strong> Recordar sus preferencias de idioma, configuración regional y otras preferencias de personalización.</li>
                <li><strong>Duración:</strong> Persistentes (generalmente de 1 mes a 1 año).</li>
                <li><strong>Titular:</strong> AURION ENERGY S.L.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                3.3. Cookies analíticas
              </h3>
              <p>
                Estas cookies nos permiten contar las visitas y fuentes de tráfico para poder medir y mejorar el rendimiento de nuestro sitio web. Nos ayudan a saber qué páginas son las más y las menos populares, y a ver cuántos visitantes acceden al sitio web y cómo se mueven por él.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Finalidad:</strong> Analizar el comportamiento de los usuarios, medir la audiencia y elaborar estadísticas de uso del sitio web.</li>
                <li><strong>Duración:</strong> Persistentes (generalmente de 1 mes a 2 años).</li>
                <li><strong>Titular:</strong> AURION ENERGY S.L. y/o terceros (por ejemplo, Google Analytics).</li>
              </ul>
              <p className="mt-4">
                <strong>Google Analytics:</strong> Utilizamos Google Analytics para obtener información sobre cómo los visitantes utilizan nuestro sitio web. Google Analytics utiliza cookies para recopilar información de forma anónima, incluyendo el número de visitantes al sitio, de dónde han llegado y las páginas que visitaron. Esta información se utiliza para mejorar el sitio web.
              </p>
              <p>
                Para más información sobre cómo Google Analytics utiliza las cookies, puede consultar la{' '}
                <a
                  href="https://policies.google.com/technologies/cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  política de cookies de Google
                </a>.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                3.4. Cookies de marketing y publicidad
              </h3>
              <p>
                Estas cookies se utilizan para mostrar anuncios relevantes para usted y sus intereses. También se utilizan para limitar el número de veces que ve un anuncio y ayudar a medir la efectividad de las campañas publicitarias.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Finalidad:</strong> Personalizar la publicidad que se muestra al usuario y medir la eficacia de las campañas publicitarias.</li>
                <li><strong>Duración:</strong> Persistentes (generalmente de 1 mes a 2 años).</li>
                <li><strong>Titular:</strong> Terceros (por ejemplo, Google Ads, Facebook Pixel, etc.).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                4. Cookies de terceros
              </h2>
              <p>
                Nuestro sitio web puede utilizar servicios de terceros que instalan cookies en su dispositivo. A continuación, detallamos algunos de los servicios de terceros que pueden utilizar cookies:
              </p>

              <div className="overflow-x-auto mt-4">
                <table className="min-w-full border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Tercero</th>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Finalidad</th>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Más información</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">Google Analytics</td>
                      <td className="border border-gray-300 px-4 py-2">Análisis del tráfico web y comportamiento del usuario</td>
                      <td className="border border-gray-300 px-4 py-2">
                        <a
                          href="https://policies.google.com/privacy"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline"
                        >
                          Política de privacidad
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">Google Maps</td>
                      <td className="border border-gray-300 px-4 py-2">Mostrar mapas interactivos y ubicaciones</td>
                      <td className="border border-gray-300 px-4 py-2">
                        <a
                          href="https://policies.google.com/privacy"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline"
                        >
                          Política de privacidad
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="mt-4">
                <strong>Importante:</strong> AURION ENERGY no tiene acceso ni control sobre las cookies utilizadas por terceros. Le recomendamos que revise las políticas de privacidad y cookies de estos servicios de terceros para obtener más información sobre cómo utilizan las cookies y cómo puede gestionar sus preferencias.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                5. ¿Cómo puede gestionar o desactivar las cookies?
              </h2>
              <p>
                Usted puede permitir, bloquear o eliminar las cookies instaladas en su dispositivo mediante la configuración de las opciones de su navegador web. A continuación, le proporcionamos enlaces a las instrucciones para gestionar las cookies en los navegadores más comunes:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Google Chrome:</strong>{' '}
                  <a
                    href="https://support.google.com/chrome/answer/95647"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Configuración de cookies en Chrome
                  </a>
                </li>
                <li>
                  <strong>Mozilla Firefox:</strong>{' '}
                  <a
                    href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Configuración de cookies en Firefox
                  </a>
                </li>
                <li>
                  <strong>Safari (macOS):</strong>{' '}
                  <a
                    href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Configuración de cookies en Safari
                  </a>
                </li>
                <li>
                  <strong>Microsoft Edge:</strong>{' '}
                  <a
                    href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Configuración de cookies en Edge
                  </a>
                </li>
                <li>
                  <strong>Opera:</strong>{' '}
                  <a
                    href="https://help.opera.com/en/latest/web-preferences/#cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Configuración de cookies en Opera
                  </a>
                </li>
              </ul>

              <p className="mt-4">
                <strong>Advertencia:</strong> Si desactiva o elimina las cookies, es posible que algunas funcionalidades del sitio web no funcionen correctamente o que su experiencia de navegación se vea afectada.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                Desactivar Google Analytics
              </h3>
              <p>
                Si desea desactivar específicamente el seguimiento de Google Analytics, puede instalar el{' '}
                <a
                  href="https://tools.google.com/dlpage/gaoptout"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  complemento de inhabilitación para navegadores de Google Analytics
                </a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                6. Consentimiento para el uso de cookies
              </h2>
              <p>
                Al acceder y utilizar nuestro sitio web, usted acepta el uso de cookies de acuerdo con esta Política de Cookies. Si no está de acuerdo con el uso de cookies, puede configurar su navegador para rechazarlas o eliminarlas siguiendo las instrucciones proporcionadas anteriormente.
              </p>
              <p>
                Al continuar navegando por nuestro sitio web sin modificar la configuración de cookies de su navegador, entendemos que acepta el uso de cookies tal como se describe en esta política.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                7. Actualización de la Política de Cookies
              </h2>
              <p>
                AURION ENERGY S.L. se reserva el derecho a modificar esta Política de Cookies en cualquier momento para adaptarla a novedades legislativas, técnicas o a cambios en los servicios que prestamos. Cualquier modificación será publicada en esta página con suficiente antelación a su aplicación.
              </p>
              <p>
                Le recomendamos que revise periódicamente esta Política de Cookies para estar informado sobre cómo utilizamos las cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                8. Más información
              </h2>
              <p>
                Para obtener más información sobre las cookies y cómo afectan a su privacidad, puede consultar los siguientes recursos:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <a
                    href="https://www.aepd.es"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Agencia Española de Protección de Datos (AEPD)
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.allaboutcookies.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    All About Cookies
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youronlinechoices.com/es/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Your Online Choices
                  </a>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                9. Contacto
              </h2>
              <p>
                Si tiene alguna pregunta o duda sobre esta Política de Cookies, puede ponerse en contacto con nosotros a través del correo electrónico <strong>info@aurionenergy.es</strong>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
